export default {
  'public_app': {
    path: '/public',
    redirect: {
      name: 'public_index'
    }
  },

  'public_index': {
    parentPath: 'public_app',
    path: 'index',
    meta: {
      title: '首页'
    }
  },
  'user_student_message': {
    parentPath: 'public_app',
    path: '/student/message',
    meta: {
      title: '图书搜索'
    }
  },

  'public_search_page': {
    parentPath: 'public_app',
    path: 'category/page',
    meta: {
      title: '图书搜索'
    }
  },

  'public_book_detail': {
    parentPath: 'public_app',
    path: 'book/detail/:id(\\d+)',
    meta: {
      title: '图书详情'
    }
  },

  'public_new_book_release': {
    parentPath: 'public_app',
    path: 'new/book/release',
    meta: {
      title: '新书讲义',
      login: true,
      roles: ['school_teacher','school_college_administrator', 'school_administrator']
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Public/route.config.js